module.exports = __webpack_public_path__ + "public/img/zfjs.d55fb4d7.png";